import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {HttpClient, HttpParams} from '@angular/common/http';
import {BaseRestService} from '../../common/BaseRestService';
import {SimpleEntityData} from '../../../types/nso-data-portal/entity-data';


@Injectable()
export class NdpSearchService extends BaseRestService {

  constructor(private http: HttpClient) {
    super('ndp_search');
  }

  searchAllNdpEntities(query: string): Observable<SimpleEntityData[]> {
    const params: HttpParams = new HttpParams().set('name', query);
    return this.http.get<SimpleEntityData[]>(this.getEndpoint([]), {params});
  }

}
